<template>		
  <el-container style="height: 100%; width: 100%;">
    <el-header>
      <div v-if="shouldShowMenu" style="background-color: #cfcfcf; width: 100%; display: flex;">
		  <div style="width: 20%;height: 100%;display: flex;justify-content: center;align-items: center;margin-left: 3%;">
			  <img style="height: 100%;width: 50%;" src="./assets/logo.png"/>

		  </div>
        <el-menu :default-active="activeIndex" class="el-menu-demo" style="background-color: #cfcfcf;margin-left: 5%;" mode="horizontal" @select="handleSelect">
          <el-menu-item index="1" style="color: aliceblue;">PRODUCT</el-menu-item>
         <!-- <el-menu-item index="2" style="color: aliceblue;">NEW</el-menu-item> -->
          <el-menu-item index="3" style="color: aliceblue;">ABOUT US</el-menu-item>
          <el-menu-item index="4" style="color: aliceblue;">PRODUCT AUTHENTICATION</el-menu-item>
          <el-menu-item index="5" style="color: aliceblue;">CONTACT US</el-menu-item>
		  <el-menu-item index="6" style="color: aliceblue;">VERIFY</el-menu-item>
        </el-menu>
      </div>
      <el-dropdown trigger="click" v-else>
        <span class="el-dropdown-link">
          MENU<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu  style="border-radius: 50px;padding: 5%;">
          <router-link to="/processing-center"><el-dropdown-item v-on:click.preven>PRODUCT</el-dropdown-item></router-link>
          <!-- <router-link to="/my-page"><el-dropdown-item v-on:click.preven>NEW</el-dropdown-item></router-link> -->
          <router-link to="/message-center"><el-dropdown-item v-on:click.preven>ABOUT US</el-dropdown-item></router-link>
          <router-link to="/order-management"><el-dropdown-item v-on:click.preven>PRODUCT AUTHENTICATION</el-dropdown-item></router-link>
          <router-link to="/Shou"><el-dropdown-item v-on:click.preven>CONTACT US</el-dropdown-item></router-link>

        </el-dropdown-menu>

      </el-dropdown>     
    </el-header>
    <el-main>
      <router-view></router-view>
    </el-main>
    <el-footer>
	  
		<div style="display: flex;width: 100%;height: 8vw;background-color: #cfcfcf;align-items: center;">
			<div style="font-size: 2vw;margin-left: 5%;">GNC PHARMA(UK) CO., LTD</div>
			<div style="font-size: 1.3vw;margin-left: 5%;">RM101, MAPLE HOUSE, 118 HIGH STREET, PURLEY, LONDON, ENGLAND, UNITED KINGDOM </div>
		</div>
	  </div>
	</el-footer>
  </el-container>
</template>

<script scoped>
export default {
  data() {
    return {
      activeName: 'second',
      shouldShowMenu: true,
	  activeIndex: '1', // 或者设置为你需要的默认值
	  snowflakes: [], // 添加一个用于存储雪花的数组
    };
  },
  mounted() {
    // 监听窗口宽度变化
    window.addEventListener('resize', this.handleResize);
    // 初始化时检查窗口宽度
    this.handleResize();
	// 开始雪花飘落效果
	    this.startSnowfall();
  },
  beforeDestroy() {
    // 在组件销毁时移除窗口宽度变化监听
    window.removeEventListener('resize', this.handleResize);
	// 停止雪花飘落效果
	    this.stopSnowfall();
  },
  methods: {
    handleSelect(index) {
      if (index === '1') {
        this.$router.push({ name: 'ProcessingCenter' });
      } else if (index === '2') {
        this.$router.push({ name: 'MyPage' });
      } else if (index === '3') {
        this.$router.push({ name: 'MessageCenter' });
      } else if (index === '4') {
        this.$router.push({ name: 'OrderManagement' });
      }else if (index === '5') {
        this.$router.push({ name: 'shou' });
      }else if (index === '6') {
        this.$router.push({ name: 'ver' });
      }
    },
    handleResize() {
      // 根据窗口宽度判断是否显示 el-menu
      this.shouldShowMenu = window.innerWidth > 810;
    },
	startSnowfall() {
	      // 这里是开始雪花飘落效果的代码
		let snowflakes = []; // 雪花数组
		
		  function setup() {
		    createCanvas(windowWidth, windowHeight);
		    fill(240);
		    noStroke();
		  }
		
		  function draw() {
		    background('skyblue');
		    let t = frameCount / 60;
		
		    for (var i = 0; i < random(5); i++) {
		      snowflakes.push(new snowflake());
		    }
		
		    for (let flake of snowflakes) {
		      flake.update(t);
		      flake.display();
		    }
		  }
		
		  function snowflake() {
		    this.posX = 0;
		    this.posY = random(-50, 0);
		    this.initialangle = random(0, 2 * PI);
		    this.size = random(2, 5);
			}
	},
	stopSnowfall() {
	      // 这里是停止雪花飘落效果的代码
		  this.snowflakes = [];
	},
  }
};
</script>

<style scoped>
	.el-menu-item:hover {
	  color: #000 !important;
	  background-color: #cfcfcf !important;
	}
	
	/* 修改 el-menu-item 选中时的样式 */
	.el-menu-item.is-active {
	  color: #000 !important;
	  background-color: #cfcfcf !important;
	}
	/* //去掉选中el-menu-item时的下划线 */
	.el-menu--horizontal > .el-menu-item {
	  border-bottom: none !important;
	}
 .el-header{
	 background-color: #cfcfcf;
	 color: #333;
	 text-align: center;
	 line-height: 60px;
	 width: 100%;
	 margin: 0;
	 padding: 0;
	 display: flex;
	 font-size: 1vw;
 }
 .el-footer {
  /* background-color: #a5a5a5; */
  color: #333;

  line-height: 3vw;
  width: 100%;
  margin: 0;
  padding: 0;
  display: flex;
  font-size: 1vw;
}

.el-main {

  color: #333;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0;
  padding: 0;
}
/* .el-dropdown-menu__item:hover {
  background-color:#fcc93a !important;
  color: #000 !important;
  padding-left: 5%;
} */

body {
  margin: 0;
  padding: 0;
  /* overflow: hidden; */
  
}

/* 添加媒体查询，根据屏幕宽度调整样式 */
@media (max-width: 768px) {
	img {
	    width: 100%;
	    height: auto;
	  }
  .el-header div {
    flex-wrap: wrap;
  }

  .el-header div > div {
    flex: 0 0 100%;
    text-align: center;
	
  }
}
.btn{
cursor:pointer;
	position:relative;
	/* padding:10px 20px; */
	background:white;
	font-size:15px;
	border-top-right-radius:10px;
	border-bottom-left-radius:10px;
	transition:all 1s;
	&:after,&:before{
		content:" ";
		width:10px;
		height:10px;
		position:absolute;
		border :0px solid #fff;
		transition:all 1s;
		}
	&:after{
		top:-1px;
		left:-1px;
		border-top:5px solid #fcc93a;
		border-left:5px solid #fc90dc;
	}
	&:before{
		bottom:-1px;
		right:-1px;
		border-bottom:5px solid #fcc93a;
		border-right:5px solid #fc90dc;
	}
	&:hover{
		border-top-right-radius:0px;
	border-bottom-left-radius:0px;

		&:before,&:after{
			
			width:100%;
			height:100%;

		}
	}
}
.btn2 {
  flex: 1 1 auto;

  text-align: center;
  text-transform: uppercase;
  transition: 0.5s;
  background-size: 200% auto;
  color: white;
 /* text-shadow: 0px 0px 10px rgba(0,0,0,0.2);*/
  box-shadow: 0 0 20px #eee;
  border-radius: 10px;
 }

/* Demo Stuff End -> */

/* <- Magic Stuff Start */

.btn2:hover {
  background-position: right center; /* change the direction of the change here */
}

.btn-1 {
  background-image: linear-gradient(to right, #f6d365 0%, #fda085 51%, #f6d365 100%);
}

.btn-2 {
  background-image: linear-gradient(to right, #fbc2eb 0%, #a6c1ee 51%, #fbc2eb 100%);
}

.btn-3 {
  background-image: linear-gradient(to right, #84fab0 0%, #8fd3f4 51%, #84fab0 100%);
}

.btn-4 {
  background-image: linear-gradient(to right, #a1c4fd 0%, #c2e9fb 51%, #a1c4fd 100%);
}

.btn-5 {
  background-image: linear-gradient(to right, #ffecd2 0%, #fcb69f 51%, #ffecd2 100%);
}
</style>
